import { htmlMutator } from './rule-creators';
import { clearOtherTags, getAttributeValue, resolveDividers, textMutator } from './utils';

const h1 = htmlMutator({
    tag: 'h1',
    opening: '# ',
    closing: '\n',
});

const h2 = htmlMutator({
    tag: 'h2',
    opening: '## ',
    closing: '\n',
});
const h3 = htmlMutator({
    tag: 'h3',
    opening: '### ',
    closing: '\n',
});
const h4 = htmlMutator({
    tag: 'h4',
    opening: '#### ',
    closing: '\n',
});
const h5 = htmlMutator({
    tag: 'h5',
    opening: '##### ',
    closing: '\n',
});
const h6 = htmlMutator({
    tag: 'h6',
    opening: '###### ',
    closing: '\n',
});
const p = htmlMutator({
    tag: 'p',
    opening: '\n',
    closing: '\n',
});

const br = htmlMutator({
    tag: 'br',
    autoClosing: '  \n',
});

const strong = htmlMutator({
    tag: 'strong',
    opening: '**',
    closing: '**',
});

const em = htmlMutator({
    tag: 'em',
    opening: '*',
    closing: '*',
});

const li = htmlMutator({
    tag: 'li',
    opening: '- ',
    closing: '',
});

export const a = htmlMutator({
    tag: 'a',
    opening: '[',
    closing: (tag: string, openingTag = '') => {
        const href = getAttributeValue(openingTag, 'href') || '';

        return `](${href})`;
    },
});

export const img = htmlMutator({
    tag: 'img',
    autoClosing: (tag: string) => {
        const src = getAttributeValue(tag, 'src') || '';
        const alt = getAttributeValue(tag, 'alt') || '';

        return `![${alt}](${src})`;
    },
});

export const mutate = textMutator([
    (text: string) => text.split('\u21b5').join(''),
    resolveDividers,
    img,
    a,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    br,
    strong,
    em,
    li,
    clearOtherTags,
]);
